// extracted by mini-css-extract-plugin
export var circle = "_bm-1";
export var exitConfirmationModal = "_bm-5";
export var iframe = "_bm-0";
export var offline = "_bm-3";
export var online = "_bm-2";
export var workstationSelectError = "_bm-4";